import { useEffect } from 'react';

export const useOnVisibilityChange = (onVisibilityChange: () => Promise<void> | void) => {
    useEffect(() => {
        const handleCallback = () => {
            if (!document.hidden) {
                onVisibilityChange();
            }
        };

        document.addEventListener('visibilitychange', handleCallback);
        window.addEventListener('focus', handleCallback);

        return () => {
            document.removeEventListener('visibilitychange', handleCallback);
            window.removeEventListener('focus', handleCallback);
        };
    }, [onVisibilityChange]);
};
